import { createContext, useState, useEffect, useContext, useRef } from "react";
import { getEnergyItems, getMe, logoutSiwe,getMining } from "../service/main/api";

const UserContext = createContext(null);

export const useUserContext = () => useContext(UserContext);
const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [energyItems, setEnergyItems] = useState([]);
  const [fetchingUser, setFetchingUser] = useState(true);
  const fetchingUserRef = useRef(fetchingUser);

  useEffect(() => {
    fetchingUserRef.current = fetchingUser;
  }, [fetchingUser]);
  const setUserData = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };
  const fetchUser = async () => {
    setFetchingUser(true);
    try {
      const res = await getMe();
      if (res?.success) {
        setUserData(res.data);
      } else {
        setUserData(null);
      }
    } catch (error) {
      setUserData(null);
    } finally {
      setFetchingUser(false);
    }
  };
  const getEnergyItemsData = async () => {
    try {
       const res = await getEnergyItems();
       if (res?.success) {
           setEnergyItems(res.data);
       } else {
           console.error("Error fetching energy items", res.message);
       }
    } catch (error) {
      console.error("Error fetching energy items", error);
    }
  };
     useEffect(() => {
       fetchUser();
       const miningInterval = setInterval(async () => {
           if(!fetchingUserRef.current && user) {
               try {
                   const res = await getMining();
                   if (res?.success) {
                     setUserData((prevUser) => ({
                       ...prevUser,
                       energy: res.data.energy,
                       balances: res.data.balances
                     }));
                   }
                 } catch (error) {
                   console.error("Error fetching mining", error);
                 }
           }
         }, 30000);
       return () => clearInterval(miningInterval);
   }, []);

   useEffect(() => {
      if (user) {
        getEnergyItemsData();
      }
   }, [user]);

  const logoutAndClearSession = async () => {
    try {
      await logoutSiwe();
    } catch (_) {}
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUserData,
        fetchUser,
        logout: logoutAndClearSession,
        fetchingUser,
        energyItems,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
